// extracted by mini-css-extract-plugin
module.exports = {"icon":"states-module__icon--35Ll5"};